<template>
  <v-flex class="displayDetails" data-qa="displaydetails-flex-pmh13e">
    <span v-if="config.title && config.dataList" data-qa="displaydetails-span-9setck">
      <font :color="darkColor" class="text-h6 font-weight-light pl-2 pt-2">{{
        config.title
      }}</font>
    </span>
    <v-layout row wrap data-qa="displaydetails-layout-7ccqzk">
      <v-flex
        v-for="(data, index) in config.dataList"
        :key="index"
        column
        wrap
        :class="config.screenType === 'confirmScreen' ? 'pa-4' : 'pa-2'"
        xs12
        sm6
        md6
        lg6
        xl6
       :data-qa="`displaydetails-flex-e3rfhbv-${index}`">
        <v-layout row wrap class="pb-0" :data-qa="`displaydetails-layout-vmn3ab-${index}`">
          <v-flex xs10 sm10 md10 lg12 xl10 class="pb-0" :data-qa="`displaydetails-flex-oztm5n-${index}`">
            <font v-if="config.translation" class="overline font-weight-bold">
              {{ $t(`${config.translation}.${data.label}`) }}
              <v-icon v-if="data.attachEditIcon && enableEditIcon && !isEditing"
                class="material"
                :color="primaryColor"
                size="24px"
                @click="toggleEditMode()"
                style="cursor: pointer;" :data-qa="`displaydetails-icon-22tjfk-${index}`">
                  {{data.attachEditIcon.icon}}
              </v-icon>
            </font>
            <font v-else class="overline font-weight-bold">
              {{ data.label }}
            </font>
            <br :data-qa="`displaydetails-br-ns3564-${index}`"  />
            <font v-if="data.subLabel" class="caption font-weight-regular">{{
              data.subLabel
            }}</font>
          </v-flex>
          <v-flex v-if="data.attachIcon" xs2 sm2 md2 lg2 xl2 class="pb-0" :data-qa="`displaydetails-flex-xklib-${index}`">
          <v-avatar @click="onIconClick({label: data.label, value: data.value})" size="24" color="#EEEEEE" :data-qa="`displaydetails-avatar-kbxal-${index}`">
            <v-icon :color="data.attachIcon.color" size="24px" :data-qa="`displaydetails-icon-sgp2h-${index}`">
              {{data.attachIcon.icon}}
            </v-icon>
          </v-avatar>
          </v-flex>
        </v-layout>
        <v-layout row wrap :data-qa="`displaydetails-layout-a4uxa8-${index}`">
          <v-flex xs12 sm12 md12 lg12 xl12 class="pt-0 pb-2" :data-qa="`displaydetails-flex-ks3t7p-${index}`">
            <div v-if="data.attachEditIcon && enableEditIcon && isEditing"
                style="display: flex; align-items: center;" :data-qa="`displaydetails-div-a2l0x-${index}`">
                <EditDisplay
                  :isEditingDisplay = isEditing
                  :accountIdDisplay = config.accountIdUpdate
                  :textFieldValue = data.value
                  @updateEditAndFieldValue="valueUpdates"
                />
              </div>
            <font
              v-if="!(data.attachEditIcon && isEditing) &&
                    (!config.valueListLabels || !config.valueListLabels.includes(data.label))"
              class="subheading font-weight-regular"
              :class="data.valueClass"
            >
              {{ data.value }}
            </font>
            <br :data-qa="`displaydetails-br-z1rfxf-${index}`"  v-if="data.subValue"/>
            <font v-if="data.subValue" class="caption font-weight-regular">{{
              data.subValue
            }}</font>
            <div
              v-show="
                config.valueListLabels.includes(data.label) && config.valueInList
              "
              v-for="(item, idx) in config.valueInList"
              :key="idx"
             :data-qa="`displaydetails-div-8wu88-${index}-${idx}`">
              <li v-for="(content, indx) in item.content" :key="indx" :data-qa="`displaydetails-li-vh7z6x-${index}-${idx}-${indx}`">{{ content.value }}</li>
            </div>

            <v-alert
              v-if="data.info"
              :color="data.infoColor"
              dense
              outlined
              text
              icon="mdi-alert-outline"
              class="pa-1"
              :data-qa="`displaydetails-alert-6fcb0p-${index}`">
              <font
                v-if="config.translation"
                class="body-2 font-weight-regular"
                >{{ $t(`${config.translation}.${data.info}`) }}</font
              >
              <font v-else class="body-2 font-weight-regular">{{
                data.info
              }}</font>
            </v-alert>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import '@/styles/components/displayDetails.scss'
import EditDisplay from '@/views/common/EditDisplay.vue'

export default {
  name: 'DisplayDetails',
  components: {
    EditDisplay
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      data: {},
      isEditing: false,
      enableEditIcon: this.$appSettings.defaultConfigurations.accountDetailsScreen.enableEditIcon
    }
  },
  methods: {
    onIconClick (eventObj) {
      this.$emit('onIconClick', eventObj)
    },
    toggleEditMode () {
      this.isEditing = !this.isEditing
    },
    valueUpdates (isEditing, editedValue) {
      this.isEditing = isEditing
      this.config.dataList.forEach(a => {
        if (a.label === 'accountName') {
          a.value = editedValue
        }
      })
    }
  }
}
</script>
